<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Mis Transacciones</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay transacciones que coincidan con la búsqueda"
                    empty-text="No hay transacciones para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(show_details)="row">
                        <b-button variant="info" size="sm" @click="row.toggleDetails" class="mr-2">
                            <i :class="row.detailsShowing ? 'material-icons rotate180' : 'material-icons'">expand_circle_down</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>

                    <template #cell(int_id)="row">
                        {{ row.item.payer === 'REMITEE' && row.item.int_id !== null ? '**' + (row.item.int_id).slice(-8) : row.item.int_id }}
                    </template>

                    <template #row-details="row">
                        <b-card class="rounded-0">
                            <b-row  align-h="center" class="mx-0" v-if="row.item.destiny_pay === 'Bank'">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Banco:</b> {{ row.item.bank_info?.name }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Cuenta {{ row.item.receiver.tc }}:</b> {{ row.item.receiver.nc }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0" v-else>
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Oficina:</b> {{ row.item.office_info ? row.item.office_info.name : '' }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Pagador:</b> {{ row.item.office_info ? row.item.office_info.payer : '' }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Documento:</b> {{ row.item.receiver.td }} {{ row.item.receiver.nd }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Email:</b> {{ row.item.receiver.email }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Valor Enviado:</b> {{ row.item.amount_swc + ' ' + row.item.currency_send }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Comisión:</b> {{ row.item.fee_net_text + ' ' + row.item.currency_send }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>IVA:</b> {{ row.item.tax_text + ' ' + row.item.currency_send }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Valor Pagado:</b> {{ row.item.amount_send_text + ' ' + row.item.currency_send }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0" v-if="row.item.promo_code">
                                <b-col cols="12" md="6" class="text-sm-right my-2 text-success">
                                    <b>Descuento aplicado:</b> - {{ Number(row.item.promo_discount_amount).toLocaleString('en-US') }} {{ row.item.currency_send }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2 text-success">
                                    <b>Código:</b> <b-badge variant="success">{{ row.item.promo_code }}</b-badge>
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Valor Recibido:</b> {{ row.item.amount_receiver_text + ' ' + row.item.currency_receiver }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                </b-col>
                            </b-row>
                            <b-row  align-h="center" class="mx-0">
                                <b-col cols="12" md="6" class="text-sm-right my-2">
                                    <b>Fecha Creación:</b> {{ row.item.date }}
                                </b-col>
                                <b-col cols="12" md="6" class="my-2">
                                    <b>Fecha Actualización:</b> {{ row.item.update }}
                                </b-col>
                            </b-row>
                            <b-row  align-h="center">
                                <b-col cols="12" class="text-center mt-3">
                                    <b-button variant="info" class="m-2" @click="print(row.item.id)">
                                        <i class="material-icons mdi mdi-printer"></i> Imprimir
                                    </b-button>
                                    <b-button variant="success" :to="'/partner/account/history/details/' + row.item.id" class="m-2">
                                        <i class="material-icons mdi mdi-eye"></i> Mas información
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                        <div :id="'ticket' + row.item.id" style="width: 280px; max-width: 280px; font-size: 14px; margin: 0;" v-if="row.item.payment === '0'">
                            <div style="width: 280px; margin: 0; text-align: center;">
                                <img :src="'/' + (partner && partner.logo && !row.item.user_id ? partner.logo : 'img/logo_header.png')"
                                     alt="logo partner" title="Logo Partner" style="max-width: 220px; padding-bottom: 12px;"/>
                            </div>
                            <p style="font-family: 'Trebuchet MS', Helvetica, sans-serif; text-align: center; width: 280px; margin: 0;">
                                <strong><u>TICKET #{{ (row.item.id).toString().padStart(6, 0) }}</u></strong>
                                <br><br>
                                <span v-if="partner">{{partner.name}}</span>
                                <br v-if="partner">
                                <span v-if="partner">{{ partner.address + ' - ' }}{{ partner.city + ', ' }}{{ partner.country }}</span>
                                <br v-if="partner"><br v-if="partner">
                                <span style="text-transform: capitalize;">Cajero: {{ user.name ? (user.name).toLowerCase() : '' }}{{ user.lname ? ' ' + ((user.lname).replace(/,/g, '')).toLowerCase() : '' }}</span>
                                <br>
                                <span>{{ new Date() | moment("DD/MM/YYYY hh:mm:ss A") }}</span>
                                <br><br>
                                <span>Válido por 30 Días</span>
                                <br><br>
                            </p>
                            <table style="font-family: 'Trebuchet MS', Helvetica, sans-serif; margin: 0; border-top: 1px solid black; border-collapse: collapse;">
                                <thead>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <th style="width: 120px; max-width: 120px;">Beneficiario</th>
                                    <th style="width: 160px; max-width: 160px; text-transform: capitalize;">{{ row.item.rname ? (row.item.rname).toLowerCase() : '' }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="row.item.rdocument !== null">
                                    <td style="width: 120px; max-width: 120px;">Documento</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.rdocument }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <td style="width: 120px; max-width: 120px;">Valor Enviado</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.amount_send_text + ' ' + row.item.currency_send }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <td style="width: 120px; max-width: 120px;">Tipo de Cambio</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.fx_rate_text }}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <th style="width: 120px; max-width: 120px;">Valor a Pagar</th>
                                    <th style="width: 160px; max-width: 160px;">{{ row.item.amount_receiver_text + ' ' + row.item.currency_receiver }}</th>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <th colspan="2"/>
                                </tr>
                                </tfoot>
                            </table>
                            <br>
                            <br>
                            <div style="text-align: center; font-family: 'Trebuchet MS', Helvetica, sans-serif; width: 280px; margin: 0;">
                                <div style="margin: -2px 0 0; border: 1px solid #333;">
                                    <p style="font-weight: 600; font-size: 16px; margin: 4px 0;">Remitente</p>
                                    <p style="font-size: 16px; margin: 4px 0; text-transform: capitalize;">{{ row.item.sname ? (row.item.sname).toLowerCase() : '' }}</p>
                                    <p style="margin: -2px 0 8px; font-size: 14px;">{{ row.item.sdocument }}</p>
                                    <p style="margin: -2px 0 8px; font-size: 14px;">{{ row.item.country_send_text + ' ➤ ' + row.item.country_receiver_text }}</p>
                                </div>
                                <br>
                                <br>
                                <p style="align-content: center; font-size: 16px;">
                                    <b>__________________________</b>
                                    <b>Firma</b>
                                </p>
                                <br>
                                <p style="align-content: center; font-size: 16px;">
                                    <b>__________________________</b>
                                    <b>Telefono</b>
                                </p>
                                <br>
                                <p style="align-content: center; font-size: 16px;">
                                    <b>¡GRACIAS POR CONFIAR EN NOSOTROS!</b>
                                </p>
                                <br>
                                <br>
                            </div>
                        </div>
                        <div :id="'ticket' + row.item.id" style="width: 280px; max-width: 280px; font-size: 14px; margin: 0;" v-else>
                            <div style="width: 280px; margin: 0; text-align: center;">
                                <img :src="'/' + (partner && partner.logo && !row.item.user_id ? partner.logo : 'img/logo_header.png')"
                                     alt="logo partner" title="Logo Partner" style="max-width: 220px; padding-bottom: 12px;"/>
                            </div>
                            <p style="font-family: 'Trebuchet MS', Helvetica, sans-serif; text-align: center; width: 280px; margin: 0;">
                                <strong><u>TICKET #{{ row.item.id ? (row.item.id).toString().padStart(6, 0) : '' }}</u></strong>
                                <br><br>
                                <span v-if="partner">{{partner.name}}</span>
                                <br v-if="partner">
                                <span v-if="partner">{{ partner.address + ' - ' }}{{ partner.city + ', ' }}{{ partner.country }}</span>
                                <br v-if="partner"><br v-if="partner">
                                <span style="text-transform: capitalize;">Cajero: {{ user.name ? (user.name).toLowerCase() : '' }}{{ user.lname ? ' ' + ((user.lname).replace(/,/g, '')).toLowerCase() : '' }}</span>
                                <br>
                                <span>{{ new Date() | moment("DD/MM/YYYY hh:mm:ss A") }}</span>
                                <br><br>
                                <strong v-if="row.item.pin !== null && row.item.country_receiver === 'CO' && (row.item.pin).includes('-')"><u>Convenio: {{ ((row.item.pin).split('-'))[0] }}</u></strong>
                                <br v-if="row.item.pin !== null && row.item.country_receiver === 'CO' && (row.item.pin).includes('-')">
                                <strong><u>PIN: {{ row.item.pin !== null && row.item.country_receiver === 'CO' && (row.item.pin).includes('-') ? ((row.item.pin).split('-'))[1] : row.item.pin }}</u></strong>
                                <br><br>
                                <span>Válido por 30 Días</span>
                                <br><br>
                            </p>
                            <table style="font-family: 'Trebuchet MS', Helvetica, sans-serif; margin: 0; border-top: 1px solid black; border-collapse: collapse;">
                                <thead>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <th style="width: 120px; max-width: 120px;">Beneficiario</th>
                                    <th style="width: 160px; max-width: 160px; text-transform: capitalize;">{{ row.item.rname ? (row.item.rname).toLowerCase() : '' }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="row.item.rdocument !== null">
                                    <td style="width: 120px; max-width: 120px;">Documento</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.rdocument }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="row.item.bank_info !== null">
                                    <td style="width: 120px; max-width: 120px;">Banco</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.bank_info.name }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="row.item.receiver.tc !== null">
                                    <td style="width: 120px; max-width: 120px;">Tipo de Cuenta</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.receiver.tc }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="row.item.receiver.nc !== null">
                                    <td style="width: 120px; max-width: 120px;">Número de Cuenta</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.receiver.nc }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="row.item.office_info !== null">
                                    <td style="width: 120px; max-width: 120px;">Oficina</td>
                                    <td style="width: 160px; max-width: 160px;">
                                        {{ row.item.office_info ? (row.item.office_info.payer + ' - ' + row.item.office_info.name) : '' }}
                                    </td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="row.item.office_info !== null">
                                    <td style="width: 120px; max-width: 120px;">Dirección</td>
                                    <td style="width: 160px; max-width: 160px;">
                                        {{ row.item.office_info ? (row.item.office_info.address + ' - ' + row.item.office_info.city) : '' }}
                                    </td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <td style="width: 120px; max-width: 120px;">Valor Enviado</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.amount_swc + ' ' + row.item.currency_send }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <td style="width: 120px; max-width: 120px;">Comisión</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.fee_net_text + ' ' + row.item.currency_send }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <td style="width: 120px; max-width: 120px;">IVA</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.tax_text + ' ' + row.item.currency_send }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <td style="width: 120px; max-width: 120px;">Valor Pagado</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.amount_send_text + ' ' + row.item.currency_send }}</td>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <td style="width: 120px; max-width: 120px;">Tipo de Cambio</td>
                                    <td style="width: 160px; max-width: 160px;">{{ row.item.fx }}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <th style="width: 120px; max-width: 120px;">Valor a Pagar</th>
                                    <th style="width: 160px; max-width: 160px;">{{ row.item.amount_receiver_text + ' ' + row.item.currency_receiver }}</th>
                                </tr>
                                <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                    <th colspan="2"/>
                                </tr>
                                </tfoot>
                            </table>
                            <br>
                            <br>
                            <div style="text-align: center; font-family: 'Trebuchet MS', Helvetica, sans-serif; width: 280px; margin: 0;">
                                <div style="margin: -2px 0 0; border: 1px solid #333;">
                                    <p style="font-weight: 600; font-size: 16px; margin: 4px 0;">Depositante</p>
                                    <p style="font-size: 16px; margin: 4px 0; text-transform: capitalize;">{{ row.item.sname ? (row.item.sname).toLowerCase() : '' }}</p>
                                    <p style="margin: -2px 0 8px; font-size: 14px;">{{ row.item.sender.email ? (row.item.sender.email).toLowerCase() : '' }}</p>
                                    <p style="margin: -2px 0 8px; font-size: 14px;">{{ row.item.country_send_text + ' => ' + row.item.country_receiver_text }}</p>
                                </div>
                                <br>
                                <br>
                                <p style="align-content: center; font-size: 16px;">
                                    <b>__________________________</b>
                                    <b>Firma</b>
                                </p>
                                <br>
                                <p style="align-content: center; font-size: 16px;">
                                    <b>¡GRACIAS POR PREFERIRNOS!</b>
                                </p>
                                <br>
                                <br>
                            </div>
                        </div>
                    </template>
                </b-table>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "PartnerHistory",
    props: [ 'user' ],
    data: () => ({
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'ID', sortable: true },
            { key: 'int_id', label: 'Codigo', sortable: true },
            { key: 'date', label: 'Fecha', sortable: true },
            { key: 'sname', label: 'Remitente', sortable: false },
            { key: 'rname', label: 'Destinatario', sortable: false },
            { key: 'country_receiver_text', label: 'País Destino', sortable: false },
            { key: 'status_text', label: 'Estado', sortable: false },
            { key: 'amount_send_usd_text', label: 'USD', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'show_details', label: 'Acción', sortable: false }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
        partner: null
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'historypage');
        this.totalRows = this.items.length;
        this.getIni();
    },
    watch: {
        'user.partner'() {
            clearTimeout(this.timeout);
            this.getIni();
        }
    },
    methods: {
        getIni() {
            axios.get('/api/customer/payments').then((res) => {
                if (res.data.status === 'success') {
                    this.partner = res.data.partner;
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
            this.timeout = setTimeout(this.getIni, 180000);
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        print(id) {
            let printContents = document.getElementById('ticket'+id).innerHTML;
            let w = window.open('_', 'Imprimir Voucher');
            w.document.write(printContents);
            w.document.close(); // necessary for IE >= 10
            w.onload=function () { // necessary if the div contain images
                w.focus(); // necessary for IE >= 10
                w.print();
                w.close();
            };
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>
@media print {
    [id*=ticket] {}
}
@media screen {
    [id*=ticket] {
        display: none;
    }
}
</style>
